// extracted by mini-css-extract-plugin
module.exports = {"normalOverlay":"style_normalOverlay__5oN5Y","darkerOverlay":"style_darkerOverlay__DyvcV"};